import { get } from 'svelte/store';
import { sid, user } from './app.store';
import { AnnouncerService } from './services/announcer.service';
import { AuthService } from './services/auth.service';
import { redirect } from './utils/pager';
// import page from 'page';
const SID_KEY = "crm.sid";
const ROOT_URL = "/";
let requestedPage = null;
export function initAppLogic() {
    subscribeAnnouncerListeners();
}
export function navigate(path) {
    redirect(path);
}
export function navigateToRoot() {
    navigate(ROOT_URL);
}
export async function login(u) {
    resetStores();
    storeUserSession(u);
    AnnouncerService.connect(u.oid);
    if (requestedPage != null) {
        navigate(requestedPage);
        requestedPage = null;
    }
    else {
        navigateToRoot();
    }
}
function storeUserSession(u) {
    try {
        let newSid = u.token;
        window.localStorage.setItem(SID_KEY, newSid);
        sid.set(newSid);
        user.set(u);
    }
    catch (err) {
        //user.set(null);
        //sid.set("");
        logout();
    }
}
export async function refreshUserSession() {
    try {
        // console.log("refreshUserSession: called");
        let _resp = await AuthService.refresh().toPromise();
        let authUserDto = _resp.payload;
        storeUserSession(authUserDto);
        AnnouncerService.connect(authUserDto.oid);
        return true;
    }
    catch (err) {
        // console.error("error refreshing user session", err);
        logout();
    }
    return false;
}
export async function logout() {
    // console.log("logout: called");
    await AuthService.logout().toPromise();
    window.localStorage.removeItem(SID_KEY);
    resetStores();
    user.set(null);
    sid.set("");
    AnnouncerService.disconnect();
    // navigateToRoot();
    redirect("/login");
}
export async function initialize() {
    // console.log("initialize: called");
    // AnnouncerService.init();
    if (requestedPage == null)
        requestedPage = window.location.pathname;
    if (get(user) != null) {
        // console.log("session user", get(user));
        return;
    }
    // console.log("initialize: no user loaded");
    let currSid = window.localStorage.getItem(SID_KEY);
    // console.log("currSid: " + currSid);
    if (currSid != null && currSid != "") {
        sid.set(currSid);
        let ok = await refreshUserSession();
        if (ok) {
            loadStores();
            // navigateToRoot();
            navigate(requestedPage);
        }
    }
    else {
        // console.log("initialize: no sid loaded, logging out");
        logout();
    }
}
function resetStores() {
}
function loadStores() {
    resetStores();
}
function subscribeAnnouncerListeners() {
    AnnouncerService.evtInboundPhoneCall.subscribe(onAnnouncedInboundPhoneCall);
}
function onAnnouncedInboundPhoneCall(event) {
    const nvpContactId = event.params.find(v => v.name === 'contactId');
    if (nvpContactId != null) {
        navigate(`/contact/${nvpContactId.value}`);
    }
}
